import { SelectOptionType } from '@portals/ui-kit';
import { ECountry, ELanguage } from '@portals/help-center-core';

// todo https://youtrack.wildberries.ru/issue/INS-973 [FE] hotfix дизейбл EN языка в селекте для внешнего СЦ - временно убираем английский язык, пока редакторы не добавят переводы
const COUNTRY_LANGUAGE_MAP: Record<string, Array<ELanguage>> = {
  ru: [ELanguage.RUSSIAN],
  ch: [ELanguage.CHINESE],
  am: [ELanguage.RUSSIAN],
  by: [ELanguage.RUSSIAN],
  kz: [ELanguage.RUSSIAN],
  kg: [ELanguage.RUSSIAN],
  uz: [ELanguage.RUSSIAN],
  ge: [ELanguage.GEORGIAN, ELanguage.RUSSIAN],
  un: [ELanguage.ENGLISH],
  tj: [ELanguage.RUSSIAN],
};

export const LANGUAGE_OPTIONS: Record<
  string,
  Array<SelectOptionType>
> = Object.entries(COUNTRY_LANGUAGE_MAP).reduce(
  (acc, [countryCode, languages]) => {
    acc[countryCode] = languages.map((language, index) => ({
      id: `${countryCode}-${index + 1}`,
      title: language.toUpperCase(),
      value: language,
    }));

    return acc;
  },
  {} as Record<string, Array<SelectOptionType>>,
);

export const NOT_TRANSLATABLE_COUNTRIES = [
  ECountry.TURKEY,
  ECountry.UNITED_NATIONS,
  ECountry.ETHIOPIA,
];
